export const SET_BUSINESSES = "SET_BUSINESSES";
export const CURRENT_BUSINESS = "CURRENT_BUSINESS";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_USER_PROFILE = "SET_USER_PROFILE";

export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const TOGGLE_ALERT = "TOGGLE_ALERT";